import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let initialised = false;

/** Initialise Application Insights browser telemetry when a connection string is configured. */
export function initTelemetry(): void {
  const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
  if (initialised || !connectionString) {
    return;
  }
  const ai = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      // No ai_user / ai_session cookies: they'd need consent, and the cookie policy promises only essential ones.
      disableCookiesUsage: true,
    },
  });
  ai.loadAppInsights();
  ai.trackPageView();
  initialised = true;
}
